module.exports = __webpack_public_path__ + "static/media/MFA-Background-006.0763caa9.png";